import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/Auth/PrivateRoute';
import AdminDashboard from './components/Admin/Dashboard';
import ApoioDashboard from './components/Apoio/Dashboard';
import UserDashboard from './components/User/Dashboard';
import { useAuth } from './contexts/AuthContext';
import './App.css';

const AppContent: React.FC = () => {
  const { isAdmin, isInscrito, isApoio } = useAuth();

  return (
    <div className="App">
      {isAdmin ? (
        <PrivateRoute requireAdmin={true}>
          <AdminDashboard />
        </PrivateRoute>
      ) : isApoio ? (
        <PrivateRoute>
          <ApoioDashboard />
        </PrivateRoute>
      ) : (
        <PrivateRoute>
          <UserDashboard />
        </PrivateRoute>
      )}
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;